document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.why-nav__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var track = document.getElementById(btn.dataset.target);
      if (!track) return;
      var card = track.querySelector('.review-card, .value-card');
      var gap = 14;
      var step = card ? card.getBoundingClientRect().width + gap : 250;
      track.scrollBy({ left: step * parseInt(btn.dataset.dir, 10), behavior: 'smooth' });
    });
  });
});
